export default __webpack_public_path__ + "images/Roka-Kandal-Chas-Kratie.webp";